import HubLeadCTA from "@/components/HubLeadCTA";
import NaatiClusterLinks from "@/components/NaatiClusterLinks";
import { createFileRoute, Link } from "@tanstack/react-router";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";
import { NAATI_VISA_SUBCLASSES } from "@/data/naati-visa-subclasses";

const TITLE = "NAATI Certified Translation แยกตาม Australian Visa Subclass | NYC";
const DESC = "เลือกวีซ่าออสเตรเลียของคุณ (Partner 820/309, Skilled 189/190/491, TSS 482, Student 500, Graduate 485, ENS 186, Visitor 600 — สอบถามฟรี ไม่มีข้อผูกมัด ทักแชทได้ทันที";

export const Route = createFileRoute("/translate/naati/visa/")({
  head: () => ({
    meta: [
      { title: ctaTitle(TITLE, "/translate/naati/visa/index", "th")}, { name: "description", content: ctaDesc(DESC, "/translate/naati/visa/index", "th")},
      { property: "og:title", content: ctaTitle(TITLE, "/translate/naati/visa/index", "th")}, { property: "og:description", content: ctaDesc(DESC, "/translate/naati/visa/index", "th")},
      { property: "og:url", content: "https://nyclanguageinstitute.com/translate/naati/visa" },
    ],
    links: canonicalAndHreflang("/translate/naati/visa", "/en/translate/naati/visa"),
    scripts: [{ type: "application/ld+json", children: JSON.stringify({ "@context":"https://schema.org","@type":"CollectionPage","@id":"https://nyclanguageinstitute.com/translate/naati/visa#collection","url":"https://nyclanguageinstitute.com/translate/naati/visa","name":"NAATI Certified Translation แยกตาม Australian Visa Subclass","inLanguage":"th","numberOfItems":NAATI_VISA_SUBCLASSES.length }) }],
  }),
  component: () => (
    <main className="min-h-screen bg-background">
      <section className="bg-gradient-to-b from-amber-100/60 to-background px-4 pt-16 pb-10">
        <div className="mx-auto max-w-5xl">
          <span className="inline-block rounded-full bg-amber-500/15 px-3 py-1 text-xs font-bold text-amber-700">NAATI × Australian Visa Matrix</span>
          <h1 className="mt-3 text-3xl font-extrabold sm:text-5xl">แปล NAATI ตามวีซ่าออสเตรเลีย 16 ชนิด</h1>
          <p className="mt-4 max-w-3xl text-lg text-muted-foreground">{DESC}</p>
        </div>
      </section>
      <section className="mx-auto max-w-5xl px-4 py-10">
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {NAATI_VISA_SUBCLASSES.map((v) => (
            <Link key={v.slug} to="/translate/naati/visa/$subclass" params={{ subclass: v.slug }}
              className="group rounded-2xl border border-slate-200 bg-white p-5 transition hover:-translate-y-0.5 hover:border-amber-400 hover:shadow-md">
              <div className="text-[11px] font-bold uppercase tracking-widest text-amber-700">Subclass {v.code}</div>
              <div className="mt-1 font-display text-lg font-extrabold text-navy-deep group-hover:text-amber-600">{v.nameTh}</div>
              <div className="mt-1 text-xs text-slate-500">{v.streamTh}</div>
              <div className="mt-3 text-xs text-slate-600">ระยะเวลา: {v.processingTimeTh}</div>
              <div className="mt-1 text-xs text-slate-600">ค่าธรรมเนียม DHA: AUD {v.govFeeAud.toLocaleString()}</div>
            </Link>
          ))}
        </div>
      </section>
      <NaatiClusterLinks />
    <HubLeadCTA locale="th" service="NAATI" />
      </main>
  ),
});
